(function($){
    /*START CUSTOM JS*/
  
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}
  
  

    /*END CUSTOM JS*/
})(jQueryTheme);